import { HTTP_TOKEN } from "./http";


// user
export const listUser = () => {
  return HTTP_TOKEN.get("account/manager/user").then((result) => {
    return result.data;
  });
};

export const createUser = (data) => {
  return HTTP_TOKEN.post("account/manager/user", data).then((result) => {
    return result.data;
  });
};

export const updateUser = (user_id, data) => {
  return HTTP_TOKEN.put(`account/manager/user/${user_id}`, data).then(
    (result) => {
      return result.data;
    }
  );
};

export const deleteUser = (user_id) => {
  return HTTP_TOKEN.delete(`account/manager/user/${user_id}`).then((result) => {
    return result.data;
  });
};

// project


export const listProject = () => {
  return HTTP_TOKEN.get("account/manager/project").then((result) => {
    return result.data;
  });
};

export const createProject = (data) => {
  return HTTP_TOKEN.post("account/manager/project", data).then((result) => {
    return result.data;
  });
};

export const updateProject = (proj_id, data) => {
  return HTTP_TOKEN.put(`account/manager/project/${proj_id}`, data).then(
    (result) => {
      return result.data;
    }
  );
};

export const deleteProject = (proj_id) => {
  return HTTP_TOKEN.delete(`account/manager/project/${proj_id}`).then((result) => {
    return result.data;
  });
};
